// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"163":"398e65262408dc82b6b5","816":"27d89688a2243f993de2"}[chunkId] + ".css";
};